import { Col, Radio, Row, Space } from "antd"
import React from "react"
import { updateInputValue } from "../../Debounce"

const paramNameStyle = {
    fontSize: 24,
    lineHeight: '28px',
    marginBottom: 7
}
const paramValueStyle = {
    fontSize: 24,
    lineHeight: '28px',
}
const radioGroupStyle = {
    height: 147.5,
    width: "100%"
}
const radioButtonStyle = {
    width: 110,
    margin: "7.5px 0px",
}
const wrapperStyle = {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 auto",
}

export const ChooseProgramDialog = ({ unitId, ecSp, ecA, ecB, ecC, ecProgId, onParamZoneClick, programs }) => {
    const [ecProg, setEcProgId] = React.useState(ecProgId);
    const [disabled, setDisabled] = React.useState(false)

    React.useEffect(() => {
        setDisabled(false);
    }, [ecProgId])

    const paramStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        cursor: disabled ? "default" : "pointer",
        color: disabled ? "grey" : "white"
    }

    const onChange = (e) => {
        setDisabled(true);
        const newEcProg = e.target.value;
        setEcProgId(newEcProg);
        updateInputValue(unitId, 'ecProgId', newEcProg);
    };

    return <div>
        <Row
            draggable="false"
            style={{ height: 112.5 }}
            className='border-down'
            onClick={() => {
                if (!disabled) {
                    onParamZoneClick();
                }
            }}
        >
            <Col span={6} className="right-border-2px" style={paramStyle}>
                <p style={paramNameStyle}>EC</p>
                <p style={paramValueStyle}>{ecSp}</p>
            </Col>
            <Col span={6} className="right-border-2px" style={paramStyle}>
                <p style={paramNameStyle}>A</p>
                <p style={paramValueStyle}>{ecA}</p>
            </Col>
            <Col span={6} className="right-border-2px" style={paramStyle}>
                <p style={paramNameStyle}>B</p>
                <p style={paramValueStyle}>{ecB}</p>
            </Col>
            <Col span={6} style={paramStyle}>
                <p style={paramNameStyle}>C</p>
                <p style={paramValueStyle}>{ecC}</p>
            </Col>
        </Row>
        <Row draggable="false" className="data-change choose-program">
            <Radio.Group onChange={onChange} value={ecProg} style={radioGroupStyle} disabled={disabled}>
                <div style={wrapperStyle}>
                    <Space>
                        <Radio.Button style={radioButtonStyle} value={0}>{programs[0]}</Radio.Button>
                        <Radio.Button style={radioButtonStyle} value={2}>{programs[2]}</Radio.Button>
                        <Radio.Button style={radioButtonStyle} value={4}>{programs[4]}</Radio.Button>
                    </Space>
                    <Space>
                        <Radio.Button style={radioButtonStyle} value={1}>{programs[1]}</Radio.Button>
                        <Radio.Button style={radioButtonStyle} value={3}>{programs[3]}</Radio.Button>
                    </Space>
                </div>
            </Radio.Group>
        </Row>
    </div>
}